export default "__VITE_ASSET__CVL7efbw__"